/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ServicedeskServiceDetailsWithoutProjectContextType } from '@jira/spa-apps__servicedesk-service-details-without-project-context/src/ServicedeskServiceDetailsWithoutProjectContextType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskServiceDetailsWithoutProjectContext: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ServicedeskServiceDetailsWithoutProjectContextType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-service-details-without-project-context", jiraSpaEntry: "async-servicedesk-service-details-without-project-context" */ '@jira/spa-apps__servicedesk-service-details-without-project-context/src/ServicedeskServiceDetailsWithoutProjectContext.tsx'
		),
	),
);

const AsyncServicedeskServiceDetailsWithoutProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskServiceDetailsWithoutProjectContext}
		pageId="spa-apps/servicedesk/service-details"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskServiceDetailsWithoutProjectContext;
